import { render } from "./Terjemahan.vue?vue&type=template&id=35a93991"
import script from "./Terjemahan.vue?vue&type=script&lang=js"
export * from "./Terjemahan.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__